import React from 'react';
import styled, { css } from 'styled-components';
import { token, spaceMixin, mediaMixin, TextButton, Paragraph } from '@zillow/constellation';
import { shouldShowContactAgentForm } from '@zillow/off-market-contact-agent-form';
import { trackFSBOClick, trackSellingTipsClick, trackContactAgentFormLinkClick } from '../utils/gaUtils';
import { useYieldCallback } from '@zillow/yield-callback';
var StyledDiv = styled.div.withConfig({
  displayName: "SellerLinks__StyledDiv",
  componentId: "sc-1b3o666-0"
})(["background-color:", ";border-style:solid;border-radius:3px;border-width:1px;border-color:", ";padding:", " ", ";", ";"], token('colors.white'), token('colors.gray300'), spaceMixin(3), spaceMixin(2), mediaMixin('md_lte', css(["padding:", ";"], spaceMixin(1.25))));

var SellerLinks = function SellerLinks(_ref) {
  var property = _ref.property,
      abTests = _ref.abTests,
      setShowContactAgentForm = _ref.setShowContactAgentForm,
      surfaceId = _ref.surfaceId,
      placementId = _ref.placementId;
  // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment
  // @ts-expect-error property type is different in off-market-contact-agent package
  // fix in STL-4217
  var showContactAgentFormLink = shouldShowContactAgentForm(property, abTests);
  var onFSBOClick = useYieldCallback(function () {
    trackFSBOClick(surfaceId, placementId);
  });
  var onSellingTipsClick = useYieldCallback(function () {
    trackSellingTipsClick(surfaceId, placementId);
  });
  return /*#__PURE__*/React.createElement(StyledDiv, {
    "data-testid": "seller-links"
  }, /*#__PURE__*/React.createElement(Paragraph, {
    fontType: "h6"
  }, "Thinking of selling? Start here"), showContactAgentFormLink && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextButton, {
    marginTop: "sm",
    fontType: "bodyHeading",
    onClick: function onClick() {
      trackContactAgentFormLinkClick(surfaceId, placementId);
      setShowContactAgentForm(true);
    },
    "data-testid": "professional-valuation-link"
  }, "Get a professional valuation"), /*#__PURE__*/React.createElement(Paragraph, null, "Connect with a local agent to see what your home could sell for.")), /*#__PURE__*/React.createElement(TextButton, {
    marginTop: "sm",
    fontType: "bodyHeading",
    as: "a",
    onClick: onSellingTipsClick,
    href: "/sellers-guide",
    "data-testid": "selling-tips-link"
  }, "Get selling tips"), /*#__PURE__*/React.createElement(Paragraph, null, "Check out our Sellers Guide for timelines, tips and advice on selling your home."), /*#__PURE__*/React.createElement(TextButton, {
    marginTop: "sm",
    fontType: "bodyHeading",
    as: "a",
    onClick: onFSBOClick,
    href: "/for-sale-by-owner",
    "data-testid": "for-sale-by-owner-link"
  }, "List for sale by owner"), /*#__PURE__*/React.createElement(Paragraph, null, "Post a listing for free, including video and unlimited photos."));
};

export default SellerLinks;
//# sourceMappingURL=SellerLinks.js.map